import type { CfdiUseType } from '@subscriptions/domain/types';
import { CfdiUses } from '@subscriptions/domain/types';

/**
 * Validated CFDI usage value object.
 *
 * Holds the SAT code (e.g. `P01`, `G03`, `G01`) — never a semantic label.
 * Presentation resolves the human-readable description via translations.
 * The empty string represents an absent/unknown code produced by soft-validation reconstruction.
 */
export type CfdiUse = Readonly<CfdiUseType | ''>;

const validUses = Object.values(CfdiUses) as string[];

/**
 * Creates a validated CfdiUse value object from a SAT code.
 *
 * @param raw - Raw CFDI SAT code as returned by the backend
 * @returns Validated CfdiUse
 * @throws Error if the code is not part of the supported catalog
 */
export const createCfdiUse = (raw: string): CfdiUse => {
  if (!validUses.includes(raw)) {
    throw new Error(`Invalid CFDI use: ${raw}. Must be one of: ${validUses.join(', ')}`);
  }
  return raw as CfdiUse;
};
